import {
  ReviewsServiceName,
  SelectedReview
} from "@bluframe/mightychroma-mightytool-frontend-types"

import Overrides from "./Overrides"
import { ReviewSectionUpdate } from "./OverridesScoreQuoteAndSection"

export type UpdateReviewSection = (update: ReviewSectionUpdate) => void

export interface Props {
  onUpdateAudio: UpdateReviewSection
  onUpdateExtra: UpdateReviewSection
  onUpdateMovie: UpdateReviewSection
  onUpdateTotal: UpdateReviewSection
  onUpdateVideo: UpdateReviewSection
  onSetReleaseDate: (releaseDate: string) => void
  review: SelectedReview["review"]
  serviceName: ReviewsServiceName
}

export interface ComponentProps extends Props {}

export default Overrides
